// ng-model, поля ввода, select и form по правилам AngularJS 1.2.29.
import { reportError } from './report';

const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
const NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))\s*$/;
// Шаблоны сайта используют форму «значение as подпись for значение in массив».
const NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+([$\w][$\w]*)\s+in\s+([\s\S]+?)$/;

let nextRadioName = 1;

function snakeCase(name) {
    return name.replace(/[A-Z]/g, (letter, pos) => (pos ? '-' : '') + letter.toLowerCase());
}

function hashKey(value) {
    if (value !== null && typeof value === 'object') {
        return 'object:' + JSON.stringify(value);
    }
    return `${typeof value}:${value}`;
}

const nullForm = {
    $addControl() {},
    $removeControl() {},
    $setValidity() {},
    $setDirty() {},
};

function findParentForm(element) {
    for (let node = element.parentNode; node; node = node.parentNode) {
        if (node.__sdControllers && node.__sdControllers.form) {
            return node.__sdControllers.form;
        }
    }
    return nullForm;
}
function toggleValidClasses(runtime, element, isValid, key) {
    const suffix = key ? '-' + snakeCase(key) : '';
    runtime.animate.removeClass(element, (isValid ? 'ng-invalid' : 'ng-valid') + suffix);
    runtime.animate.addClass(element, (isValid ? 'ng-valid' : 'ng-invalid') + suffix);
}

export class NgModelController {
    constructor(scope, element, attrs, runtime) {
        this.$viewValue = Number.NaN;
        this.$modelValue = Number.NaN;
        this.$parsers = [];
        this.$formatters = [];
        this.$viewChangeListeners = [];
        this.$pristine = true;
        this.$dirty = false;
        this.$valid = true;
        this.$invalid = false;
        this.$error = {};
        this.$name = attrs.name;
        this.$$invalidCount = 0;
        this.$$element = element;
        this.$$runtime = runtime;
        this.$$scope = scope;
        this.$$getter = runtime.parse(attrs.ngModel);
        if (!this.$$getter.assign) {
            reportError(`ng-model: выражение «${attrs.ngModel}» нельзя изменить.`);
        }
        this.$$parentForm = findParentForm(element);
        element.classList.add('ng-pristine', 'ng-valid');
        this.$$parentForm.$addControl(this);
        scope.$on('$destroy', () => this.$$parentForm.$removeControl(this));

        scope.$watch(() => {
            const value = this.$$getter(scope);
            if (this.$modelValue !== value && !(Number.isNaN(this.$modelValue) && Number.isNaN(value))) {
                this.$modelValue = value;
                let formatted = value;
                for (let i = this.$formatters.length - 1; i >= 0; i--) {
                    formatted = this.$formatters[i](formatted);
                }
                if (this.$viewValue !== formatted) {
                    this.$viewValue = formatted;
                    this.$render();
                }
            }
            return value;
        });
    }

    $render() {}

    $isEmpty(value) {
        return value === undefined || value === '' || value === null || value !== value; // eslint-disable-line no-self-compare
    }

    $setValidity(key, isValid) {
        if (this.$error[key] === !isValid) {
            return;
        }
        if (isValid) {
            if (this.$error[key]) {
                this.$$invalidCount--;
            }
            if (!this.$$invalidCount) {
                toggleValidClasses(this.$$runtime, this.$$element, true);
                this.$valid = true;
                this.$invalid = false;
            }
        } else {
            toggleValidClasses(this.$$runtime, this.$$element, false);
            this.$invalid = true;
            this.$valid = false;
            this.$$invalidCount++;
        }
        this.$error[key] = !isValid;
        toggleValidClasses(this.$$runtime, this.$$element, isValid, key);
        this.$$parentForm.$setValidity(key, isValid, this);
    }

    $setViewValue(value) {
        this.$viewValue = value;
        if (this.$pristine) {
            this.$dirty = true;
            this.$pristine = false;
            this.$$runtime.animate.removeClass(this.$$element, 'ng-pristine');
            this.$$runtime.animate.addClass(this.$$element, 'ng-dirty');
            this.$$parentForm.$setDirty();
        }
        let parsed = value;
        this.$parsers.forEach(parser => {
            parsed = parser(parsed);
        });
        if (this.$modelValue !== parsed) {
            this.$modelValue = parsed;
            if (this.$$getter.assign) {
                this.$$getter.assign(this.$$scope, parsed);
            }
            this.$viewChangeListeners.forEach(listener => {
                try {
                    listener();
                } catch (error) {
                    reportError(error);
                }
            });
        }
    }
}

export class FormController {
    constructor(element, attrs, runtime) {
        this.$name = attrs.name;
        this.$dirty = false;
        this.$pristine = true;
        this.$valid = true;
        this.$invalid = false;
        this.$error = {};
        this.$$element = element;
        this.$$runtime = runtime;
        this.$$controls = [];
        this.$$invalidCount = 0;
        this.$$parentForm = findParentForm(element);
        this.$$parentForm.$addControl(this);
        element.classList.add('ng-pristine', 'ng-valid');
    }

    $addControl(control) {
        this.$$controls.push(control);
        if (control.$name && !Object.prototype.hasOwnProperty.call(this, control.$name)) {
            this[control.$name] = control;
        }
    }

    $removeControl(control) {
        if (control.$name && this[control.$name] === control) {
            delete this[control.$name];
        }
        Object.keys(this.$error).forEach(key => this.$setValidity(key, true, control));
        const index = this.$$controls.indexOf(control);
        if (index >= 0) {
            this.$$controls.splice(index, 1);
        }
    }

    $setValidity(key, isValid, control) {
        const queue = this.$error[key];
        if (isValid) {
            if (queue) {
                const index = queue.indexOf(control);
                if (index >= 0) {
                    queue.splice(index, 1);
                }
                if (!queue.length) {
                    this.$$invalidCount--;
                    if (!this.$$invalidCount) {
                        toggleValidClasses(this.$$runtime, this.$$element, true);
                        this.$valid = true;
                        this.$invalid = false;
                    }
                    this.$error[key] = false;
                    toggleValidClasses(this.$$runtime, this.$$element, true, key);
                    this.$$parentForm.$setValidity(key, true, this);
                }
            }
        } else {
            if (!this.$$invalidCount) {
                toggleValidClasses(this.$$runtime, this.$$element, false);
            }
            if (queue) {
                if (queue.indexOf(control) === -1) {
                    queue.push(control);
                }
            } else {
                this.$error[key] = [control];
                this.$$invalidCount++;
                toggleValidClasses(this.$$runtime, this.$$element, false, key);
                this.$$parentForm.$setValidity(key, false, this);
            }
            this.$valid = false;
            this.$invalid = true;
        }
    }

    $setDirty() {
        this.$$runtime.animate.removeClass(this.$$element, 'ng-pristine');
        this.$$runtime.animate.addClass(this.$$element, 'ng-dirty');
        this.$dirty = true;
        this.$pristine = false;
        this.$$parentForm.$setDirty();
    }
}

function validate(ctrl, key, valid, value) {
    ctrl.$setValidity(key, valid);
    return valid ? value : undefined;
}

function textInput(scope, element, attrs, ctrl) {
    let composing = false;
    element.addEventListener('compositionstart', () => {
        composing = true;
    });
    const listener = () => {
        if (composing) {
            return;
        }
        const value = element.value.trim();
        if (ctrl.$viewValue !== value) {
            if (scope.$root.$$phase) {
                ctrl.$setViewValue(value);
            } else {
                scope.$apply(() => ctrl.$setViewValue(value));
            }
        }
    };
    element.addEventListener('compositionend', () => {
        composing = false;
        listener();
    });
    element.addEventListener('input', listener);
    element.addEventListener('change', listener);
    ctrl.$render = () => {
        element.value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
    };
}

function noInput() {}

const INPUT_TYPES = {
    text: textInput,
    number(scope, element, attrs, ctrl) {
        textInput(scope, element, attrs, ctrl);
        ctrl.$parsers.push(value => {
            const empty = ctrl.$isEmpty(value);
            if (empty || NUMBER_REGEXP.test(value)) {
                ctrl.$setValidity('number', true);
                if (value === '') {
                    return null;
                }
                return empty ? value : parseFloat(value);
            }
            ctrl.$setValidity('number', false);
            return undefined;
        });
        ctrl.$formatters.push(value => (ctrl.$isEmpty(value) ? '' : '' + value));
        if (attrs.min) {
            const validator = value => validate(ctrl, 'min', ctrl.$isEmpty(value) || value >= parseFloat(attrs.min), value);
            ctrl.$parsers.push(validator);
            ctrl.$formatters.push(validator);
        }
        ctrl.$formatters.push(value => validate(ctrl, 'number', ctrl.$isEmpty(value) || typeof value === 'number' || NUMBER_REGEXP.test(value), value));
    },
    email(scope, element, attrs, ctrl) {
        textInput(scope, element, attrs, ctrl);
        const validator = value => validate(ctrl, 'email', ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value), value);
        ctrl.$formatters.push(validator);
        ctrl.$parsers.push(validator);
    },
    radio(scope, element, attrs, ctrl) {
        if (attrs.name === undefined) {
            element.setAttribute('name', `sd-radio-${nextRadioName++}`);
        }
        element.addEventListener('click', () => {
            if (element.checked) {
                scope.$apply(() => ctrl.$setViewValue(attrs.value));
            }
        });
        ctrl.$render = () => {
            // eslint-disable-next-line eqeqeq
            element.checked = attrs.value == ctrl.$viewValue;
        };
        attrs.$observe('value', ctrl.$render);
    },
    checkbox(scope, element, attrs, ctrl) {
        element.addEventListener('click', () => {
            scope.$apply(() => ctrl.$setViewValue(element.checked));
        });
        ctrl.$render = () => {
            element.checked = ctrl.$viewValue;
        };
        ctrl.$isEmpty = value => value !== true;
        ctrl.$formatters.push(value => value === true);
    },
    hidden: noInput,
    button: noInput,
    submit: noInput,
    reset: noInput,
    file: noInput,
};

function setupSelect(scope, select, attrs, ctrl, runtime) {
    let unknownOption = null;
    const removeUnknown = () => {
        if (unknownOption && unknownOption.parentNode) {
            unknownOption.parentNode.removeChild(unknownOption);
        }
    };
    const options = () => Array.from(select.options).filter(option => option !== unknownOption);

    if (attrs.ngOptions) {
        setupNgOptions(scope, select, attrs, ctrl, runtime);
        return;
    }

    ctrl.$render = () => {
        const viewValue = ctrl.$viewValue;
        const match = options().find(option => option.value === String(viewValue));
        if (match && viewValue !== undefined && viewValue !== null) {
            removeUnknown();
            select.value = String(viewValue);
            return;
        }
        const emptyOption = options().find(option => option.value === '');
        if ((viewValue === undefined || viewValue === null) && emptyOption) {
            removeUnknown();
            select.value = '';
            return;
        }
        if (viewValue === '' && emptyOption) {
            removeUnknown();
            emptyOption.selected = true;
            return;
        }
        if (!unknownOption) {
            unknownOption = document.createElement('option');
        }
        const unknownValue = `? ${hashKey(viewValue)} ?`;
        unknownOption.value = unknownValue;
        select.insertBefore(unknownOption, select.firstChild);
        select.value = unknownValue;
        unknownOption.selected = true;
    };
    select.addEventListener('change', () => {
        scope.$apply(() => {
            removeUnknown();
            ctrl.$setViewValue(select.value);
        });
    });
    // Опции из ng-repeat и интерполяции появляются после проверки изменений: показываем значение заново.
    scope.$watch(() => options().map(option => option.value).join('\u0001'), () => ctrl.$render());
}

function setupNgOptions(scope, select, attrs, ctrl, runtime) {
    const match = attrs.ngOptions.match(NG_OPTIONS_REGEXP);
    if (!match) {
        reportError(`ng-options: неверное выражение «${attrs.ngOptions}»`);
        return;
    }
    const parse = runtime.parse;
    const displayFn = parse(match[2] || match[1]);
    const valueName = match[3];
    const valueFn = parse(match[2] ? match[1] : valueName);
    const valuesFn = parse(match[4]);
    const nullOption = Array.from(select.options).find(option => option.value === '') || null;
    if (nullOption) {
        nullOption.parentNode.removeChild(nullOption);
    }
    select.innerHTML = '';

    const items = () => (valuesFn(scope) || []).map((value, key) => ({ key, locals: { [valueName]: value } }));

    const render = () => {
        const modelValue = ctrl.$modelValue;
        let selectedSet = false;
        const rendered = items().map(({ key, locals }) => {
            const selected = modelValue === valueFn(scope, locals);
            selectedSet = selectedSet || selected;
            const label = displayFn(scope, locals);
            return { id: key, label: label == null ? '' : label, selected };
        });
        if (nullOption || modelValue === null) {
            rendered.unshift({ id: '', label: nullOption ? nullOption.textContent : '', selected: !selectedSet, isNull: true });
        } else if (!selectedSet) {
            rendered.unshift({ id: '?', label: '', selected: true });
        }
        select.innerHTML = '';
        rendered.forEach(item => {
            const option = item.isNull && nullOption ? nullOption : document.createElement('option');
            option.setAttribute('value', String(item.id));
            option.selected = item.selected;
            if (item.selected) {
                option.setAttribute('selected', 'selected');
            } else {
                option.removeAttribute('selected');
            }
            if (!item.isNull || !nullOption) {
                option.setAttribute('label', String(item.label));
                option.textContent = item.label;
            }
            select.appendChild(option);
        });
    };
    ctrl.$render = render;
    scope.$watch(() => items().map(({ locals }) => `|${displayFn(scope, locals)}`).join('\u0001'), render);
    scope.$watch(() => ctrl.$modelValue, render);
    select.addEventListener('change', () => {
        scope.$apply(() => {
            const key = select.value;
            if (key === '' || key === '?') {
                ctrl.$setViewValue(key === '' ? null : undefined);
                return;
            }
            const item = items().find(candidate => String(candidate.key) === key);
            ctrl.$setViewValue(item ? valueFn(scope, item.locals) : undefined);
        });
    });
}

export function registerModelDirectives(directives) {
    directives.set('ngModel', {
        controller(scope, element, attrs, runtime) {
            return new NgModelController(scope, element, attrs, runtime);
        },
    });

    directives.set('form', {
        restrict: 'E',
        controller(scope, element, attrs, runtime) {
            const form = new FormController(element, attrs, runtime);
            if (attrs.name) {
                scope[attrs.name] = form;
            }
            return form;
        },
        link(scope, element, attrs) {
            if (!attrs.action) {
                element.addEventListener('submit', event => event.preventDefault());
            }
        },
    });

    const inputDirective = {
        restrict: 'E',
        require: '?ngModel',
        link(scope, element, attrs, runtime, ctrl) {
            if (!ctrl) {
                return;
            }
            const type = element.nodeName === 'TEXTAREA' ? 'text' : (attrs.type || 'text').toLowerCase();
            (INPUT_TYPES[type] || INPUT_TYPES.text)(scope, element, attrs, ctrl, runtime);
        },
    };
    directives.set('input', inputDirective);
    directives.set('textarea', inputDirective);

    directives.set('select', {
        restrict: 'E',
        require: '?ngModel',
        link(scope, element, attrs, runtime, ctrl) {
            if (ctrl) {
                setupSelect(scope, element, attrs, ctrl, runtime);
            }
        },
    });

    directives.set('ngValue', {
        priority: 100,
        link(scope, element, attrs) {
            if (/^(true|false|\d+)$/.test(attrs.ngValue)) {
                attrs.$set('value', scope.$eval(attrs.ngValue), true, 'value');
            } else {
                scope.$watch(attrs.ngValue, value => attrs.$set('value', value, true, 'value'));
            }
        },
    });

    directives.set('ngChange', {
        require: 'ngModel',
        link(scope, element, attrs, runtime, ctrl) {
            if (ctrl) {
                ctrl.$viewChangeListeners.push(() => scope.$eval(attrs.ngChange));
            }
        },
    });

    directives.set('required', {
        require: '?ngModel',
        link(scope, element, attrs, runtime, ctrl) {
            if (!ctrl) {
                return;
            }
            const validator = value => {
                if (ctrl.$isEmpty(value)) {
                    ctrl.$setValidity('required', false);
                    return undefined;
                }
                ctrl.$setValidity('required', true);
                return value;
            };
            ctrl.$formatters.push(validator);
            ctrl.$parsers.unshift(validator);
            attrs.$observe('required', () => validator(ctrl.$viewValue));
        },
    });
}
